var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_408",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916748 2.94934H20.0931V22.0001H0.916748V2.94934Z",
    fill: "#FFC700"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1417 17.0897C14.5326 17.6975 13.8095 18.179 13.0139 18.5067C12.2182 18.8343 11.3657 19.0017 10.5052 18.999C9.64526 19.0017 8.79321 18.8345 7.99793 18.5072C7.20266 18.1799 6.4798 17.6989 5.87078 17.0917C5.26071 16.4892 4.77663 15.7714 4.44675 14.98C4.11686 14.1886 3.94777 13.3395 3.94932 12.4821C3.94766 11.625 4.11658 10.7761 4.44623 9.98497C4.77588 9.19381 5.25968 8.47615 5.86944 7.87382C6.47858 7.26637 7.20164 6.78514 7.99715 6.45772C8.79267 6.1303 9.64499 5.96313 10.5052 5.96579C11.3656 5.96337 12.2179 6.13065 13.0135 6.45805C13.8091 6.78546 14.5323 7.26656 15.1417 7.87382C15.751 8.47643 16.2343 9.19419 16.5636 9.98532C16.8929 10.7764 17.0616 11.6252 17.0598 12.4821C17.0617 13.3389 16.8931 14.1876 16.5638 14.9786C16.2345 15.7697 15.7511 16.4873 15.1417 17.0897ZM10.5052 2.94934C5.21955 2.95001 0.916748 7.22595 0.916748 12.4821C0.916748 17.7382 5.21955 22.0155 10.5052 22.0155C15.7909 22.0155 20.0924 17.7382 20.0924 12.4821C20.0931 7.22595 15.7916 2.94934 10.5059 2.94934H10.5052Z",
    fill: "#FFC700"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9497 2.22424H21.6982V1.48238H20.9497V2.22424ZM20.9497 0.744546H21.6982V0H20.9497V0.744546ZM18.8469 2.94462H19.5451V2.21954H18.8469V2.94462Z",
    fill: "#FFC700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4626 4.33834H18.1668V3.64481H17.4626V4.33834ZM19.5451 3.64414H20.328V2.94592H19.5451V3.64414ZM16.7623 3.64414L17.4626 3.64481V2.97949H16.7623V3.64414ZM18.8469 4.33834H19.5451V3.64414L18.8469 3.64481V4.33834ZM20.2105 1.48167H20.9497V0.744507H20.2105V1.48167ZM18.8469 2.21883H20.2105V1.48167H18.8469V2.21883ZM18.1668 3.64481H18.8456V2.21883H18.1668V3.64481ZM18.1668 5.03857H17.4619V4.33834H16.2944V4.84186H15.6687V5.46422H16.3682V6.1564H15.6687V5.46422L14.9255 5.46489V6.55116H14.2219V7.24469H13.7566V7.94089H13.2437C12.6676 8.79286 11.2242 11.4454 10.7871 12.5283C9.21479 10.3531 7.99424 9.48907 7.03284 9.17688C6.5132 9.0218 5.88815 9.58306 6.75086 10.4672C8.72939 12.6304 9.35242 14.4216 9.95397 15.8516C10.2722 16.6049 11.6989 16.7217 11.9855 15.955C12.5945 14.3323 13.478 12.5109 14.5226 11.0137V10.2376H15.0812V9.53942H15.6687V8.72908H16.3702V7.94828H15.6606V7.23864H16.3702V7.94828H17.0638L17.0618 7.24536H17.619V6.39675H18.2434V5.81266H18.8469V4.33834H18.1668V5.03857Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorton);
export default __webpack_public_path__ + "static/media/norton.34e96a4a380572b25c80db641858a28c.svg";
export { ForwardRef as ReactComponent };